<script>
    export default {
        props: {
            title: {
                type: String,
                default: 'Tab'
            },
            classNames: {
                type: String,
                default: ''
            },
            persistent: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                isActive: false
            }
        },
        created() {
            this.$parent.allTabs.push(this);
        }
    }
</script>

<template>
    <template v-if="persistent">
        <div :class="classNames" v-show="isActive">
            <slot></slot>
        </div>
    </template>
    <template v-else>
        <div :class="classNames" v-if="isActive">
            <slot></slot>
        </div>
    </template>
</template>
